export default "__VITE_ASSET__C8YnR3Dd__"